import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-list-dialog.component',
  templateUrl: './list-dialog.component.html',
  styleUrls: ['./list-dialog.component.scss', '../../../../scss/app-styles.scss'],
})
export class ListDialogComponent {
  data = inject(MAT_DIALOG_DATA);

}
